import { HomeIcon } from '../../../components/Icons/HomeIcon';
// import { SettingsIcon } from '../../../components/Icons/SettingsIcon';
import { UserIcon } from '../../../components/Icons/UserIcon';
import { HOME, USER } from '../../../routes/routeConstants';

export const navConfig = [
  {
    title: 'Home',
    path: HOME,
    icon: <HomeIcon />,
  },

  {
    title: 'User',
    path: USER,
    icon: <UserIcon />,
  },

  // {
  //   title: 'Settings',
  //   path: SETTINGS,
  //   icon: <SettingsIcon />,
  // },
];
